// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { spSelectTag } from "#/admin/legacy/sp-select/index.js";

/** Reads server-rendered select items from an assessment-builder root. */
export function assessmentSelectItems(element) {
  return JSON.parse(element.dataset.selectItems || "{}");
}

/** Returns the select items a view's options carry, or an empty map. */
export function viewSelectItems(options = {}) {
  return options.selectItems || {};
}

/** Returns template `attributes` with the sp-select tag helper and, per `itemNames` entry, the items its key names. */
export function selectItemsContext(attributes, selectItems, itemNames = {}) {
  const items = Object.fromEntries(Object.entries(itemNames).map(([name, key]) => [name, selectItems[key]]));

  return {
    ...attributes,
    sp_select_tag: spSelectTag,
    ...items,
  };
}
